import {CompanyEntity, firstOrUndefined, getObjectId, ServiceTypeEntity} from "@ots-frontend/ots-data";
import {Grid} from "@mantine/core";
import {
  ServiceEventTypeServiceTypeDataTableCard
} from "../../card/ServiceEventTypeServiceTypeDataTableCard/ServiceEventTypeServiceTypeDataTableCard";
import {ServiceTypeFacetDataTableCard} from "../../card/ServiceTypeFacetDataTableCard/ServiceTypeFacetDataTableCard";
import {ServiceTypeModeDataTableCard} from "../../card/ServiceTypeModeDataTableCard/ServiceTypeModeDataTableCard";
import {
  ServiceTypeFacetModeDataTableCard
} from "../../card/ServiceTypeFacetModeDataTableCard/ServiceTypeFacetModeDataTableCard";
import {useState} from "react";
import {CompanySelect} from "../../select/entity/CompanySelect/CompanySelect";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {useTranslation} from "react-i18next";

export type ServiceTypeConfigurationProps = {
  serviceType: ServiceTypeEntity
}

export const ServiceTypeConfiguration = (props: ServiceTypeConfigurationProps) => {
  const {serviceType} = props;

  const {t} = useTranslation(["common"]);
  const {companyId} = useAuth()

  const [company, setCompany] = useState<CompanyEntity | string | undefined>(companyId);

  return (
    <Grid>
      <Grid.Col span={12}>
        <CompanySelect
          size="xs"
          label={t("common.entity.company", "Company")}
          placeholder={t<string>("common.entity.company", "Company")}
          value={getObjectId(company)}
          onEntityChange={e => setCompany(firstOrUndefined(e))}/>
      </Grid.Col>
      {company &&
        <>
          <Grid.Col span={6}>
            <ServiceEventTypeServiceTypeDataTableCard company={company} serviceType={serviceType}/>
          </Grid.Col>
          <Grid.Col span={6}>
            <ServiceTypeFacetDataTableCard company={company} serviceType={serviceType}/>
          </Grid.Col>
          <Grid.Col span={6}>
            <ServiceTypeModeDataTableCard company={company} serviceType={serviceType}/>
          </Grid.Col>
          <Grid.Col span={6}>
            <ServiceTypeFacetModeDataTableCard company={company} serviceType={serviceType}/>
          </Grid.Col>
        </>
      }
    </Grid>
  );
};

